import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import { fetchDeductions } from '@perpay-web/fintech/actions/entities/deductions';
import { fetchUserStatus } from '@perpay-web/fintech/actions/entities/userStatus';
import { fetchABTest } from '@perpay-web/fintech/actions/shared/abTests';
import { fetchPinwheelEligibility as fetchPinwheelEligibilityAction } from '@perpay-web/fintech/actions/shared/pinwheelEligibility';

export function fetchPinwheelEligibility(action$) {
    return action$.pipe(
        ofType(fetchPinwheelEligibilityAction().type),
        mergeMap(() => [
            fetchABTest('pinwheel'),
            fetchUserStatus(),
            fetchDeductions(),
        ]),
    );
}
